export { navigate };
export { reload };
import { getCurrentUrl } from '../shared/getCurrentUrl.js';
import { normalizeUrlArgument } from './normalizeUrlArgument.js';
import { firstRenderStartPromise, renderPageClientSide } from './renderPageClientSide.js';
import { assertClientRouting } from './utils.js';
assertClientRouting();
/** Programmatically navigate to a new page.
 *
 * https://vike.dev/navigate
 *
 * @param url - The URL of the new page.
 * @param keepScrollPosition - Don't scroll to the top of the page, instead keep the current scroll position.
 * @param overwriteLastHistoryEntry - Don't create a new entry in the browser's history, instead let the new URL replace the current URL. (This effectively removes the current URL from the browser history).
 */
async function navigate(url, { keepScrollPosition = false, overwriteLastHistoryEntry = false, pageContext } = {}) {
    normalizeUrlArgument(url, 'navigate');
    // If `hydrationCanBeAborted === false` (e.g. Vue) then we can apply navigate() only after hydration is done
    await firstRenderStartPromise;
    const scrollTarget = { preserveScroll: keepScrollPosition };
    await renderPageClientSide({
        scrollTarget,
        urlOriginal: url,
        overwriteLastHistoryEntry,
        isBackwardNavigation: false,
        pageContextInitClient: pageContext
    });
}
async function reload() {
    await navigate(getCurrentUrl());
}
